import Image from 'next/image';

import { Button } from 'shared/components/ui/button';

interface IframeLoginPromptProps {
  onContinue: () => void;
  popupBlocked: boolean;
}

export function IframeLoginPrompt({
  onContinue,
  popupBlocked,
}: IframeLoginPromptProps) {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm rounded-lg bg-white p-8 shadow-lg">
        <div className="flex flex-col items-center space-y-6">
          <div className="flex items-center gap-3">
            <Image
              src="/logo_avatar.png"
              alt="Norm Ai"
              width={48}
              height={48}
              className="rounded-lg"
            />
            <span className="text-3xl font-bold text-blue-500">Norm Ai</span>
          </div>
          <div className="text-center">
            <p className="text-base text-gray-700">Welcome</p>
            <p className="mt-3 text-sm text-gray-500">
              Log in to Norm Ai to continue.
            </p>
          </div>
          <div className="w-full pt-2">
            <Button
              variant="highlight"
              size="lg"
              className="w-full"
              onClick={onContinue}
            >
              Continue
            </Button>
          </div>
          {popupBlocked && (
            <p className="text-center text-sm text-red-500">
              Popup blocked. Please allow popups for this site.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
